import { Link } from "@inertiajs/react"
import { GoogleButton } from "@/components/landing/google-button"

interface HeaderProps {
  signedIn?: boolean
  onSignOut?: () => void
}

export function LandingHeader({ signedIn = false, onSignOut }: HeaderProps) {
  return (
    <header className="border-b border-border">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link href="/" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-primary" />
          <span className="text-lg font-semibold text-foreground">
            AdWizard
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm">
          {signedIn ? (
            <>
              <Link href="/dashboard" className="text-muted-foreground hover:text-foreground">
                Dashboard
              </Link>
              <button
                type="button"
                onClick={onSignOut}
                className="cursor-pointer rounded-md border border-border px-4 py-2 font-medium text-foreground hover:bg-card"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <a href="#how-it-works" className="text-muted-foreground hover:text-foreground">
                How it works
              </a>
              <a href="#tools" className="text-muted-foreground hover:text-foreground">
                Tools
              </a>
              <GoogleButton label="Sign in" />
            </>
          )}
        </nav>
      </div>
    </header>
  )
}
